import React from 'react';

import { css } from '@emotion/core';
import { Flex, Text } from '@rebass/emotion';
import Colors from '@theme/colors';

interface FormRadioButton {
  name: string;
  value: string;
  selectedValue: string;
  onChange: (e: { target: { value: string } }) => void;
  onBlur: (e: { target: { value: string } }) => void;
  id: string;
  label: string;
}

const selectedStyle = css`
  :after {
    background: ${Colors.science37};
    content: '';
    display: inline-block;
    height: 10px;
    left: 7px;
    width: 10px;
    position: absolute;
    top: 7px;
    border-radius: 50%;
  }
`;

const FormRadioButton = ({ name, value, selectedValue, onChange, onBlur, id, label }: FormRadioButton) => {
  const selected = selectedValue === value;

  return (
    <Flex mb={[4]} width={'50%'}>
      <input
        name={name}
        type="radio"
        id={id}
        value={value} // could be something else for output?
        checked={selectedValue === value}
        onChange={onChange}
        onBlur={onBlur}
        css={css`
          height: 1px;
          opacity: 0;
          width: 1px;
        `}
      />
      <label
        css={css`
          position: relative;
          :before {
            border: 2px solid ${selected && value ? Colors.science37 : Colors.neutral75};
            content: '';
            display: inline-block;
            height: 20px;
            width: 20px;
            border-radius: 50%;
            color: ${Colors.neutral75};
            top: 0px;
            position: absolute;
          }
          ${selected && selectedStyle}
        `}
        htmlFor={id}
      >
        <Text
          fontSize={[2]}
          css={css`
            vertical-align: super;
            display: inline-block;
            margin-left: 10px;
            padding-left: 24px;
          `}
        >
          {label}
        </Text>
      </label>
    </Flex>
  );
};

export default FormRadioButton;
